import { Carousel, CarouselItem } from '@nespresso-design-system/components'
import styles from './CarouselWrapper.module.scss'
import { forwardRef, JSX } from 'react'

type CarouselWrapperProps = {
    carouselOptions?: {
        focus?: {
            mobile?: 'center' | 'left' | 'right'
            tablet?: 'center' | 'left' | 'right'
            desktop?: 'center' | 'left' | 'right'
        }
        speed?: { mobile?: number; tablet?: number; desktop?: number }
        navPosition: 'center' | 'top'
        ['data-slides']: number
    }
    carouselItemOptions?: { style: object }
    items: JSX.Element[]
}
const CarouselWrapper = forwardRef(
    (
        { carouselOptions, items, carouselItemOptions }: CarouselWrapperProps,
        ref
    ) => {
        // TODO https://nestle.atlassian.net/browse/DIGEX-13629
        // Update Carousel component from the Design System. This has a role="tabpanel"
        // ARIA role should be appropriate for the element
        // WCAG 1.3.1 Info and Relationships
        return (
            <Carousel
                api={{
                    type: 'slide',
                    focus: 'left',
                    mediaQuery: 'min',
                    easing: 'ease',
                    padding: { inline: '0px', left: '0px', right: '0px' },
                    breakpoints: {
                        320: {
                            speed: carouselOptions?.speed?.mobile ?? 500,
                            focus: carouselOptions?.focus?.mobile
                        },
                        480: {
                            padding: { left: '0px', right: '0px' }
                        },
                        768: {
                            speed: carouselOptions?.speed?.tablet || 500,
                            focus: carouselOptions?.focus?.tablet || 'left'
                        },
                        1024: {
                            speed: carouselOptions?.speed?.desktop || 500,
                            focus: carouselOptions?.focus?.desktop
                        },
                        1280: {
                            padding: { left: '145px', right: '0px' }
                        }
                    },

                    trimSpace: false
                }}
                ref={ref}
                navPosition={carouselOptions?.navPosition}
                data-slides={carouselOptions?.['data-slides']}
                className={styles.carouselSlider}>
                {items.map((item, index) => (
                    <CarouselItem
                        key={index}
                        className={carouselItemOptions?.style}>
                        {item}
                    </CarouselItem>
                ))}
            </Carousel>
        )
    }
)

export default CarouselWrapper
